import { study } from './study.query';
import { studyLog } from './study-log.query';

export const apps = {
  study,
  studyLog,
};
